// src/libraries/LabelLibrary.js
import Label from './Label';
import layerLibrary from '../canvas/LayerLibrary';
import layoutEngine from './layoutEngine';
const listeners = [];





class LabelLibrary {
  constructor() {
    this.labels = {}; // Structure: { layerId: [Label, Label, ...] } // New structure: { cellName: { layerId: [Label, Label, ...] } }

   
  }

  // Add a new label
  
  addLabel(cellName,layerId, x, y, text = '', color = '#ffffff',fontType = 'monospace', rotation = 0,justification = 'centerleft') {
    const id = Date.now() + Math.random(); // Unique id
     const fontSize = this.getCellFontSize(cellName);
    const label = new Label({ id, text, x, y, layerId, color,fontType, rotation, justification,fontSize });
    console.log("rotation in add function",rotation)
    if (!this.labels[cellName]) this.labels[cellName] = {};
    if (!this.labels[cellName][layerId]) this.labels[cellName][layerId] = [];
  
    this.labels[cellName][layerId].push(label);


    const cell = window.layoutEngine.getCellByName(cellName);
  if (cell) {
    cell.elements = cell.elements || [];
    cell.elements.push(label);
  }
    return label;
  }





 _syncedCells = new Set();

  syncFromUploaded(cellName) {
  if (!cellName || this._syncedCells.has(cellName)) return;

  const up = window.layoutEngine?.getUploadedCell?.(cellName);
  if (!up?.elements) return;

  if (!this.labels[cellName]) this.labels[cellName] = {};

  up.elements.forEach(el => {
    const isLabel = el?.type === 'label' || el?.type === 'Label';
    if (!isLabel) return;

    const x = el.coordinates?.[0]?.[0] ?? el.x ?? 0;
    const y = el.coordinates?.[0]?.[1] ?? el.y ?? 0;
    // const layerId =
    //   el.layerId ||
    //   `${el.layerNumber ?? el.layer}:${el.datatypeNumber ?? el.datatype ?? 0}`;
     // ALWAYS use normalized layer + datatype id
    const ln = el.layerNumber ?? el.layer ?? 0;
    const dt = el.datatypeNumber ?? el.datatype ?? 0;
    const layerId = `${ln}:${dt}`;

    if (!this.labels[cellName][layerId]) this.labels[cellName][layerId] = [];

    // de-dupe by id
    if (!this.labels[cellName][layerId].some(l => l.id === el.id)) {
      const color = (layerLibrary?.getLayerById?.(layerId) || {}).color;
      const label = new Label({
        id: el.id,
        text: el.name || el.text || '',
        x, y, layerId, color,
        rotation: el.rotation || 0,
        justification: el.justification || 'centerleft',
        fontType: el.fontType || 'monospace',
        visible: el.visible !== false,
        locked: !!el.locked
      });
      this.labels[cellName][layerId].push(label);
    }
  });

  this._syncedCells.add(cellName);
}

  // Get all labels (flat array)
  // getAllLabels() {
  //   return Object.values(this.labels)
  //     .flat()
  //     .filter(label => label && typeof label.text === 'string' && label.text.trim() !== '');
  // }
  getAllLabels(cellName = null) {
  let all = [];
  if (!cellName) return all;

  // NEW: pull uploaded labels into library once
  this.syncFromUploaded(cellName);

  const cellLabels = this.labels[cellName] || {};
  for (const layerId in cellLabels) {
    for (const label of cellLabels[layerId]) {
      if (label && typeof label.text === 'string' && label.text.trim() !== '') {
        all.push(label);
      }
    }
  }
  return all;
}





// helper (add inside class)
_reflectToLayout(cellName, labelId, updates = {}) {
  [window.layoutEngine?.getCellByName?.(cellName),
   window.layoutEngine?.getUploadedCell?.(cellName)]
  .forEach(cell => {
    const el = cell?.elements?.find(e => e.id === labelId);
    if (!el) return;
    // name vs text
    if ('text' in updates) {
      if (el.type === 'label' || el.type === 'Label') el.name = updates.text;
      if (el.type === 'text') el.text = updates.text;
    }
    if ('visible' in updates) el.visible = updates.visible;
    if ('locked' in updates)  el.locked  = updates.locked;
    if ('color' in updates)   el.color   = updates.color;
    if ('rotation' in updates) el.rotation = updates.rotation;
    if ('justification' in updates) el.justification = updates.justification;
    if ('fontType' in updates) el.fontType = updates.fontType;
  });
}



  //shiv code
//   getAllLabelsRaw() {
//   return Object.values(this.labels).flat();
// }
getAllLabelsRaw(cellName = null) {
  if (!cellName) return [];
  return Object.values(this.labels[cellName]).flat();
}

// end code

  

  // Delete a specific label by id
  // deleteLabel(layerId, labelId) {
  //   if (!this.labels[layerId]) return;
  //   this.labels[layerId] = this.labels[layerId].filter(label => label.id !== labelId);
  // }




  // Restore full label state from undo/redo
// setAllLabels(newLabels) {
//   this.labels = {};

//   for (let label of newLabels) {
//     if (!this.labels[label.layerId]) {
//       this.labels[label.layerId] = [];
//     }
//     this.labels[label.layerId].push(new Label({ ...label }));
//   }
// }
setAllLabels(newLabels) {
  this.labels = {};
  for (const cellName in newLabels) {
    this.labels[cellName] = {};
    for (const layerId in newLabels[cellName]) {
      this.labels[cellName][layerId] = newLabels[cellName][layerId].map(labelData => new Label(labelData));
    }
  }
}




 getLabelById(labelId) {
   for (const cellName in this.labels) {
     for (const layerId in this.labels[cellName]) {
       const found = this.labels[cellName][layerId].find(l => l.id === labelId);
       if (found) return found;
     }
   }
   return null;
 }
getAllLabelMap() {
  return this.labels;
}



// ✅ Toggle visibility of a single label

// toggleLabelVisibility(labelId) {
//   for (const cellName in this.labels) {
//     for (const layerId in this.labels[cellName]) {
//       const label = this.labels[cellName][layerId].find(l => l.id === labelId);
//       if (label) {
//         label.visible = !label.visible;
//         return;
//       }
//     }
//   }
// }

  setAllLock(layerId, lockState) {
  // 1) In-memory labels
  for (const cellName in this.labels) {
    if (this.labels[cellName][layerId]) {
      this.labels[cellName][layerId].forEach(label => {
        label.locked = lockState;
      });
    }
  }

  // 2) Uploaded + created labels in layoutEngine
  for (const cellName in this.labels) {
    const layoutCell   = layoutEngine.getCellByName(cellName);
    const uploadedCell = layoutEngine.getUploadedCell(cellName);

    [layoutCell, uploadedCell].forEach(cell => {
      if (cell?.elements?.length) {
        cell.elements.forEach(el => {
          if (el.type === "label" && el.layerId === layerId) {
            el.locked = lockState;
          }
        });
      }
    });
  }
}





// updateLabelText(labelId, newText) {
//   for (const cellName in this.labels) {
//     for (const layerId in this.labels[cellName]) {
//       const label = this.labels[cellName][layerId].find(l => l.id === labelId);
//       if (label) {
//         label.text = newText;
//         return;
//       }
//     }
//   }
// }

updateLabelText(labelId, newText) {
  for (const cellName in this.labels) {
    for (const lid in this.labels[cellName]) {
      const L = this.labels[cellName][lid].find(l => l.id === labelId);
      if (L) { L.text = newText; this._reflectToLayout(cellName, labelId, { text: newText }); return; }
    }
  }
}

toggleLabelVisibility(labelId) {
  for (const cellName in this.labels) {
    for (const lid in this.labels[cellName]) {
      const L = this.labels[cellName][lid].find(l => l.id === labelId);
      if (L) { L.visible = !L.visible; this._reflectToLayout(cellName, labelId, { visible: L.visible }); return; }
    }
  }
}

toggleLabelLock(labelId) {
  for (const cellName in this.labels) {
    for (const lid in this.labels[cellName]) {
      const L = this.labels[cellName][lid].find(l => l.id === labelId);
      if (L) { L.locked = !L.locked; this._reflectToLayout(cellName, labelId, { locked: L.locked }); return; }
    }
  }
}

deleteLabel(cellName, layerId, labelId) {
  if (!this.labels[cellName] || !this.labels[cellName][layerId]) return;
  this.labels[cellName][layerId] =
    this.labels[cellName][layerId].filter(l => l.id !== labelId);

  [window.layoutEngine?.getCellByName?.(cellName),
   window.layoutEngine?.getUploadedCell?.(cellName)]
  .forEach(cell => {
    if (cell?.elements) cell.elements = cell.elements.filter(e => e.id !== labelId);
  });
}


// ✅ Toggle lock of a single label

// toggleLabelLock(labelId) {
//   for (const cellName in this.labels) {
//     for (const layerId in this.labels[cellName]) {
//       const label = this.labels[cellName][layerId].find(l => l.id === labelId);
//       if (label) {
//         label.locked = !label.locked;
//         return;
//       }
//     }
//   }
// }


// ✅ Toggle visibility for all labels
toggleAllVisibility(visibleState) {
  for (const cellName in this.labels) {
    for (const layerId in this.labels[cellName]) {
      this.labels[cellName][layerId].forEach(label => label.visible = visibleState);
    }
  }
}
// toggleAllVisibility(visibleState) {
//   for (const cellName in this.labels) {
//     for (const layerId in this.labels[cellName]) {
//       this.labels[cellName][layerId].forEach(label => label.visible = visibleState);
//     }
//   }
// }


// ✅ Toggle lock for all labels
// toggleAllLock(lockState) {
//   for (const layerId in this.labels) {
//     this.labels[layerId].forEach(label => label.locked = lockState);
//   }
// }
toggleAllLock(lockState) {
  for (const cellName in this.labels) {
    for (const layerId in this.labels[cellName]) {
      this.labels[cellName][layerId].forEach(label => label.locked = lockState);
    }
  }
}


// ✅ Delete all labels
deleteAllLabels() {
  this.labels = {};
}
// deleteAllLabels() {
//   this.labels = {};
// }

// LabelLibrary.js
updateColorByLayer(layerId, newColor) {
  // 1) In-memory store (cellName → layerId → [labels])
  for (const cellName in this.labels) {
    const byLayer = this.labels[cellName] || {};
    if (byLayer[layerId]) {
      byLayer[layerId].forEach(l => { l.color = newColor; });
    }
  }

  // Helper: element kis layer ka hai?
  const belongs = (el) => {
    if (!el) return false;
    if (el.layerId) return String(el.layerId) === String(layerId);
    const lid = `${el.layerNumber ?? el.layer}:${el.datatypeNumber ?? el.datatype ?? 0}`;
    return lid === layerId;
  };

  // 2) layoutEngine cells (uploaded + created) me label elements ko touch karo
  const touchCell = (cell) => {
    if (!cell?.elements) return;
    for (const el of cell.elements) {
      if ((el.type === 'label' || el.type === 'Label') && belongs(el)) {
        el.color = newColor;
      }
    }
  };

  try {
    (window.layoutEngine?.getUploadedCells?.() || []).forEach(touchCell);
    (window.layoutEngine?.getCells?.() || []).forEach(touchCell);
  } catch (_) {}

  // redraw ki zaroorat nahi — LayerLibrary.updateColor already calls draw()
}


// updateColorByLayer(cellName, layerId, newColor) {
//   if (!this.labels[cellName] || !this.labels[cellName][layerId]) return;
//   this.labels[cellName][layerId].forEach(label => {
//     label.color = newColor;
//   });
// }


updateLabelRotation(labelId, angle) {
  for (const cellName in this.labels) {
    for (const layerId in this.labels[cellName]) {
      const label = this.labels[cellName][layerId].find(l => l.id === labelId);
      if (label) { label.rotation = angle; return; }
    }
  }
}
// updateLabelRotation(labelId, angle) {
//   for (const cellName in this.labels) {
//     for (const layerId in this.labels[cellName]) {
//       const label = this.labels[cellName][layerId].find(l => l.id === labelId);
//       if (label) {
//         label.rotation = angle;
//         return;
//       }
//     }
//   }
// }


updateLabelFontType(labelId, fontType) {
  for (const layerId in this.labels) {
    const label = this.labels[layerId].find(l => l.id === labelId);
    if (label) {
      label.fontType = fontType;
      return;
    }
  }
}

// --- add to LabelLibrary class ---

// Set font size for a single cell only
setFontSizeForCell(cellName, size) {
  size = Number(size);
  if (isNaN(size) || size < 1) return;

  // 1) Update in-memory labels for this cell
  if (this.labels[cellName]) {
    for (const layerId in this.labels[cellName]) {
      this.labels[cellName][layerId].forEach(label => {
        label.fontSize = size;
      });
    }
  }

  // 2) Update layoutEngine objects (uploaded + created) for this cell
  const touch = (cell) => {
    if (!cell?.elements) return;
    for (const el of cell.elements) {
      if (el.type === "label" || el.type === "Label") {
        el.fontSize = size;
      }
    }
  };

  try {
    const layoutCell = window.layoutEngine?.getCellByName?.(cellName);
    const uploadedCell = window.layoutEngine?.getUploadedCell?.(cellName);
    touch(layoutCell);
    touch(uploadedCell);
  } catch (_) {}
}

// Get a sensible font size for a cell (if multiple labels exist, prefer the first / most recent)
getCellFontSize(cellName) {
  const DEFAULT = 14;
  if (!cellName) return DEFAULT;

  // If we have an explicit store, try to derive from labels
  if (this.labels[cellName]) {
    for (const layerId in this.labels[cellName]) {
      const arr = this.labels[cellName][layerId];
      if (arr && arr.length > 0) {
        // pick the first label that has fontSize set
        const found = arr.find(l => typeof l.fontSize === 'number' && !isNaN(l.fontSize));
        if (found) return found.fontSize;
      }
    }
  }

  // fallback: inspect layoutEngine cell elements
  try {
    const uploaded = window.layoutEngine?.getUploadedCell?.(cellName);
    const layout = window.layoutEngine?.getCellByName?.(cellName);
    const pick = (cell) => {
      if (!cell?.elements) return null;
      for (const el of cell.elements) {
        if ((el.type === 'label' || el.type === 'Label') && typeof el.fontSize === 'number') {
          return el.fontSize;
        }
      }
      return null;
    };
    return pick(uploaded) ?? pick(layout) ?? DEFAULT;
  } catch (_) {
    return DEFAULT;
  }
}


setAllFontSize(size) {
  size = Number(size);
  if (isNaN(size) || size < 1) return;

  // 1) Update all in-memory labels
  for (const cellName in this.labels) {
    for (const layerId in this.labels[cellName]) {
      this.labels[cellName][layerId].forEach(label => {
        label.fontSize = size;
      });
    }
  }

  // 2) Update layoutEngine objects (uploaded + created)
  const touch = (cell) => {
    if (!cell?.elements) return;
    for (const el of cell.elements) {
      if (el.type === "label" || el.type === "Label") {
        el.fontSize = size;
      }
    }
  };

  try {
    (window.layoutEngine?.getUploadedCells?.() || []).forEach(touch);
    (window.layoutEngine?.getCells?.() || []).forEach(touch);
  } catch (_) {}
}


// LabelLibrary.js
setLayerVisibility(layerId, isVisible) {
  // 1) In-memory labels
  for (const cellName in this.labels) {
    if (this.labels[cellName][layerId]) {
      this.labels[cellName][layerId].forEach(label => {
        label.visible = isVisible;
      });
    }
  }

  // 2) Mirror to layoutEngine cells (uploaded + manual)
  const touch = (cell) => {
    if (!cell?.elements) return;
    for (const el of cell.elements) {
      // accept both label.type variants + both layer id encodings
      const elKey = `${el.layerNumber ?? el.layer}:${el.datatypeNumber ?? el.datatype ?? 0}`;
      const isLabel = el?.type === 'label' || el?.type === 'Label';
      const match = (el.layerId && el.layerId === layerId) || elKey === layerId;
      if (isLabel && match) el.visible = isVisible;
    }
  };

  try {
    (window.layoutEngine?.getUploadedCells?.() || []).forEach(touch);
    (window.layoutEngine?.getCells?.() || []).forEach(touch);
  } catch (_) {}

  // (Canvas redraw LayerLibrary.toggleVisibility se ho hi raha hai)
}



// updateLabelJustification(labelId, justification) {
//   const validOptions = ['upperleft', 'upperright', 'lowerleft', 'lowerright', 'center', 'centerleft', 'centerright'];
//   if (!validOptions.includes(justification)) {
//     console.warn(`Invalid justification: ${justification}. Valid options are: ${validOptions.join(', ')}`);
//     return;
//   }

//   for (const layerId in this.labels) {
//     const label = this.labels[layerId].find(l => l.id === labelId);
//     if (label) {
//       label.justification = justification; // Update the justification
//       console.log(`Justification set to ${justification} for label ${labelId}`);
//       return;
//     }
//   }
// }
updateLabelJustification(labelId, justification) {
  const validOptions = ['upperleft', 'upperright', 'lowerleft', 'lowerright', 'center', 'centerleft', 'centerright'];
  if (!validOptions.includes(justification)) {
    console.warn(`Invalid justification: ${justification}. Valid options are: ${validOptions.join(', ')}`);
    return;
  }

  for (const cellName in this.labels) {
    for (const layerId in this.labels[cellName]) {
      const label = this.labels[cellName][layerId].find(l => l.id === labelId);
      if (label) {
        label.justification = justification;
        console.log(`Justification set to ${justification} for label ${labelId}`);
        return;
      }
    }
  }
}

    drawLabel(ctx, element) {
  if (!element || !element.coordinates || !element.coordinates[0]) return;

  const [x, y] = element.coordinates[0];
  const text = element.name || "";
  const rotation = element.rotation || 0;
    const lid =
    element.layerId ||
    `${element.layerNumber ?? element.layer}:${element.datatypeNumber ?? element.datatype ?? 0}`;
     if (element.visible === false) return;
  if (layerLibrary?.isLayerVisible && !layerLibrary.isLayerVisible(lid)) return;
  const layer = layerLibrary?.getLayerById?.(lid) || null;
  const color = element.color || layer?.color; // layer color is the source of truth
  // safety-only: canvas ko valid color chahiye hota hai
  ctx.fillStyle = element.color || layer?.color;
  const fontType = element.fontType || "monospace";
  const fontSize = element.fontSize || 14;
  const justification = element.justification || "centerleft";

  ctx.save();

  ctx.translate(x, y);
  const ang = (((rotation % 360) + 360) % 360);
  ctx.rotate(ang * Math.PI / 180);

  // Set alignment
  switch (justification) {
    case 'upperleft':
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';
      break;
    case 'upperright':
      ctx.textAlign = 'right';
      ctx.textBaseline = 'top';
      break;
    case 'lowerleft':
      ctx.textAlign = 'left';
      ctx.textBaseline = 'bottom';
      break;
    case 'lowerright':
      ctx.textAlign = 'right';
      ctx.textBaseline = 'bottom';
      break;
    case 'center':
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      break;
    case 'centerleft':
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      break;
    case 'centerright':
      ctx.textAlign = 'right';
      ctx.textBaseline = 'middle';
      break;
    default:
      ctx.textAlign = 'left';
      ctx.textBaseline = 'alphabetic';
  }

  ctx.fillStyle = color;
  ctx.font = `${fontSize}px ${fontType}`;
  ctx.fillText(text, 0, 0);

  // Plus sign reference
  ctx.beginPath();
  ctx.strokeStyle = "#00ff00";
  ctx.lineWidth = 1;
  ctx.moveTo(-5, 0);
  ctx.lineTo(5, 0);
  ctx.moveTo(0, -5);
  ctx.lineTo(0, 5);
  ctx.stroke();

  ctx.restore();
}


  // ✅ Rotation-aware, no change to external behavior (assume world transform already applied)
drawSingle(ctx, label, offsetX = 0, offsetY = 0, scale = 1) {
  ctx.save();

  const lid =
    label.layerId ||
    `${label.layerNumber ?? label.layer}:${label.datatypeNumber ?? label.datatype ?? 0}`;
    if (label?.visible === false) return;
  if (layerLibrary?.isLayerVisible && !layerLibrary.isLayerVisible(lid)) return;
  const layer =
    (layerLibrary && layerLibrary.getLayerById)
      ? layerLibrary.getLayerById(lid)
      : null;

  // Font & color-
   ctx.fillStyle = label.color || layer?.color || '#ffffff';
  ctx.font = `${label.fontSize}px ${label.fontType || 'monospace'}`;

  // Text alignment from justification
  const j = label.justification || 'centerleft';
  if (j === 'upperleft')      { ctx.textAlign = 'left';  ctx.textBaseline = 'top'; }
  else if (j === 'upperright'){ ctx.textAlign = 'right'; ctx.textBaseline = 'top'; }
  else if (j === 'lowerleft') { ctx.textAlign = 'left';  ctx.textBaseline = 'bottom'; }
  else if (j === 'lowerright'){ ctx.textAlign = 'right'; ctx.textBaseline = 'bottom'; }
  else if (j === 'center')    { ctx.textAlign = 'center';ctx.textBaseline = 'middle'; }
  else if (j === 'centerleft'){ ctx.textAlign = 'left';  ctx.textBaseline = 'middle'; }
  else if (j === 'centerright'){ctx.textAlign = 'right'; ctx.textBaseline = 'middle'; }
  else                        { ctx.textAlign = 'left';  ctx.textBaseline = 'alphabetic'; }

  // 🔁 Draw text rotated around its own origin (“+”)
  // 🔁 normalize + rotate around origin (“+”)
// 🔁 rotation ko text ke origin (“+”) par lagao
const ang = (((label.rotation || 0) % 360) + 360) % 360; // 0..359
ctx.save();
ctx.translate(label.x, label.y);
ctx.rotate(ang * Math.PI / 180);   // NOTE: yaha minus sign nahi hoga
ctx.fillText(label.text || '', 0, 0);
ctx.restore();
console.log('DRAW in draw single ang=', ang, 'raw=', label.rotation);




  // ➕ Unrotated reference plus at label origin
  ctx.save();
  ctx.translate(label.x, label.y);
  const plus = 5;
  ctx.strokeStyle = "#00ff00";
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(-plus, 0); ctx.lineTo(plus, 0);
  ctx.moveTo(0, -plus); ctx.lineTo(0, plus);
  ctx.stroke();
  ctx.restore();
  

  ctx.restore();
}




  // Draw all labels
  // ✅ Clean transform stack, rotation-aware text, unrotated plus, same selection box behavior
drawAllLabels(ctx, offsetX, offsetY, scale, activeLayerId = null, cellName = null) {
  ctx.save();
  ctx.translate(offsetX, offsetY);
  ctx.scale(scale, scale);

  const allLabels = this.getAllLabels(cellName) || [];

  for (let label of allLabels) {
    if (label?.visible === false) continue;
    // (Intentionally NOT filtering by activeLayerId to avoid changing existing behavior)

    // Font & color (set per label)
    // LabelLibrary.js (inside drawAllLabels loop)
const lid =
  label.layerId ||
  `${label.layerNumber ?? label.layer}:${label.datatypeNumber ?? label.datatype ?? 0}`;
  if (layerLibrary?.isLayerVisible && !layerLibrary.isLayerVisible(lid)) continue;
const layer =
  (layerLibrary && layerLibrary.getLayerById)
    ? layerLibrary.getLayerById(lid)
    : null;

ctx.fillStyle = label.color || layer?.color || '#ffffff';   // ✅
ctx.font = `${label.fontSize}px ${label.fontType || 'monospace'}`;


    // Text alignment from justification
    const j = label.justification || 'centerleft';
    if (j === 'upperleft')      { ctx.textAlign = 'left';  ctx.textBaseline = 'top'; }
    else if (j === 'upperright'){ ctx.textAlign = 'right'; ctx.textBaseline = 'top'; }
    else if (j === 'lowerleft') { ctx.textAlign = 'left';  ctx.textBaseline = 'bottom'; }
    else if (j === 'lowerright'){ ctx.textAlign = 'right'; ctx.textBaseline = 'bottom'; }
    else if (j === 'center')    { ctx.textAlign = 'center';ctx.textBaseline = 'middle'; }
    else if (j === 'centerleft'){ ctx.textAlign = 'left';  ctx.textBaseline = 'middle'; }
    else if (j === 'centerright'){ctx.textAlign = 'right'; ctx.textBaseline = 'middle'; }
    else                        { ctx.textAlign = 'left';  ctx.textBaseline = 'alphabetic'; }

    // 1) Rotated label text around its origin
    // 1) Rotated text around its own origin
const ang = (((label.rotation || 0) % 360) + 360) % 360;
ctx.save();
ctx.translate(label.x, label.y);
ctx.rotate(ang * Math.PI / 180);   // minus nahi
ctx.fillText(label.text || '', 0, 0);
ctx.restore();
//console.log('DRAW  in draw all ang=', ang, 'raw=', label.rotation);


    // 2) Unrotated plus sign at origin
    if ((label.text || '').length >= 1) {
      ctx.save();
      ctx.translate(label.x, label.y);
      const plus = 5;
      ctx.strokeStyle = "#00ff00";
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(-plus, 0); ctx.lineTo(plus, 0);
      ctx.moveTo(0, -plus); ctx.lineTo(0, plus);
      ctx.stroke();
      ctx.restore();
    }

    // 3) Axis-aligned dashed selection box (same behavior)
    // if (label.selected) {
    //   const width  = ctx.measureText(label.text || '').width;
    //   const height = label.fontSize;

    //   let boxX = label.x;
    //   let boxY = label.y;

    //   switch (j) {
    //     case 'upperleft': break;
    //     case 'upperright': boxX -= width; break;
    //     case 'lowerleft': boxY -= height; break;
    //     case 'lowerright': boxX -= width; boxY -= height; break;
    //     case 'center': boxX -= width / 2; boxY -= height / 2; break;
    //     case 'centerleft': boxY -= height / 2; break;
    //     case 'centerright': boxX -= width; boxY -= height / 2; break;
    //   }

    //   ctx.strokeStyle = '#ffffff';
    //   ctx.lineWidth = 2 / scale;
    //   ctx.setLineDash([4, 2]);
    //   ctx.strokeRect(boxX - 4, boxY - 2, width + 8, height + 8);
    //   ctx.setLineDash([]);
    // }
    if (label.selected) {
  const width  = ctx.measureText(label.text || '').width;
  const height = label.fontSize;
  let boxX = 0, boxY = 0;   // ab origin-relative
  switch (j) {
    case 'upperleft': break;
    case 'upperright': boxX -= width; break;
    case 'lowerleft': boxY -= height; break;
    case 'lowerright': boxX -= width; boxY -= height; break;
    case 'center': boxX -= width / 2; boxY -= height / 2; break;
    case 'centerleft': boxY -= height / 2; break;
    case 'centerright': boxX -= width; boxY -= height / 2; break;
  }
  ctx.save();
  ctx.translate(label.x, label.y);
  ctx.rotate(ang * Math.PI / 180);   // wahi 'ang' jo text draw karne me use kiya
  ctx.strokeStyle = '#ffffff';
  ctx.lineWidth = 2 / scale;
  ctx.setLineDash([4, 2]);
  ctx.strokeRect(boxX - 4, boxY - 2, width + 8, height + 8);
  ctx.setLineDash([]);
  ctx.restore();
}
  }

  ctx.restore();
}


  getDragBoundingBox(label, ctx) {
  const width = ctx.measureText(label.text).width;
  const height = label.fontSize;

  let boxX = label.x;
  let boxY = label.y;

  switch (label.justification) {
    case 'upperleft': break;
    case 'upperright': boxX -= width; break;
    case 'lowerleft': boxY -= height; break;
    case 'lowerright': boxX -= width; boxY -= height; break;
    case 'center': boxX -= width / 2; boxY -= height / 2; break;
    case 'centerleft': boxY -= height / 2; break;
    case 'centerright': boxX -= width; boxY -= height / 2; break;
  }

  const textLeft = boxX - 4;
  const textTop = boxY - 2;
  const textRight = boxX + width + 4;
  const textBottom = boxY + height + 6;

  const plusLeft = label.x - 5;
  const plusTop = label.y - 5;
  const plusRight = label.x + 5;
  const plusBottom = label.y + 5;

  return {
    left: Math.min(textLeft, plusLeft),
    top: Math.min(textTop, plusTop),
    right: Math.max(textRight, plusRight),
    bottom: Math.max(textBottom, plusBottom)
  };
}

}

// Create singleton instance
const labelLibrary = new LabelLibrary();
export default labelLibrary;
